<template>
  <div class="banner-area style01" :class="{'listing-style' : !payment, 'is-clean-layout' : isCleanLayout}" :style="{ backgroundImage : `url(https://skypanel1.s3-eu-west-1.amazonaws.com/media_files/sXDoTWb3MGwgx9hmaT3BaYSjE38GvqJRVbzva965.jpeg)` }">
    <connection />
    <div class="container">
      <strong class="title">{{ subTitle }}</strong>
      <h1>{{ title }}</h1>
      <a nohref @click="back" class="btn btn-secondary" v-if="payment">
        <i class="icon-arrow_left"></i>
        {{ $t('banner.return') }}
      </a>
      <div v-else-if="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="/">{{ $t('banner.home') }}</a>
          </li>
          <li class="breadcrumb-item active">{{ $t('banner.results') }}</li>
        </ol>
      </div>
      <div class="banner-img" :class="{'style02' : category == 'airporthotel' || category == 'airportlounge'}">
        <transition name="fade" mode="out-in" :duration="500" v-if="!loading">
          <img key="1" v-if="category == 'airporthotel'" :src="`${cdn}/images/img35.png`" alt="Skyparksecure steve" />
          <img key="2" v-else-if="category == 'airportlounge'" :src="`${cdn}/images/img48.png`" alt="Skyparksecure steve" />
          <img key="3" id="promoActive" v-else-if="category == 'airportparking' && promoBoxActive" :src="`${cdn}/images/img34.png`" alt="Skyparksecure steve" />
          <img key="4" id="promoInactive" v-else-if="category == 'airportparking' && !promoBoxActive" :src="`${cdn}/images/img65.png`" alt="Skyparksecure steve" />
          <img key="5" v-else :src="`${cdn}/images/img34.png`" alt="Skyparksecure steve" />
        </transition>
      </div>
      <div class="promo_holder" v-if="promoBox">
        <form @submit.prevent>
          <strong class="title-promo" v-if="promoBoxActive">{{ $t('airportparking.results.promo.active') }}</strong>
          <strong class="title-promo text-white" v-if="promoBoxInvalid">{{ $t('airportparking.results.promo.invalid') }}</strong>
          <div class="input-holder">
            <div class="input-col">
              <input
                type="text"
                class="form-control dust-gray"
                v-bind:placeholder="promoBoxPlaceholder"
                v-model="promo"
                @keyup.enter="searchAgain"
              />
            </div>
            <div class="input-col">
              <button class="btn btn-secondary text-uppercase" type="button" @click="searchAgain">{{ $t('airportparking.results.filters.search_again') }}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { sync, get } from "vuex-pathify";
import mixins from "@/mixins";
import { eventBus } from "@/eventBus";
import Connection from "./connection";

export default {
  name: "page-banner",
  components: { Connection },
  mixins: [mixins.globals],
  computed: {
    ...sync('quoteTemp/*'),
    quote: get("quote"),
    resultsPage() {
      return `/booking-quote/`;
    },
    isCleanLayout() {
      return this.$route.query['clean'] === '1';
    }
  },
  props: {
    title: { type: String, default: "" },
    subTitle: { type: String, default: "" },
    image: { type: String, default: "" },
    promoBox: { type: Boolean, default: true },
    promoBoxPlaceholder: { type: String, default: "" },
    promoBoxActive: { type: Boolean, default: false },
    promoBoxInvalid: { type: Boolean, default: false },
    payment: { default: false },
    breadcrumb: { default: true },
    loading: { default: false }
  },
  methods: {
    searchAgain() {
      eventBus.$emit("SEARCH");
    },
    back() {
      delete this.quote._timestamp;
      delete this.quote.quoteID;

      return this.$router.replace({ path: `${this.category}-results`, query: this.quote }).catch(() => {});
    }
  },
};
</script>
